(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var Accordion = /*#__PURE__*/function () {
  function Accordion() {
    _classCallCheck(this, Accordion);
    this.init();
  }
  _createClass(Accordion, [{
    key: "init",
    value: function init() {
      (function ($) {
        var $accordion = $('.js-accordion');
        $accordion.on("click", ".header", function () {
          $(this).toggleClass("header--active").next().slideToggle().end().find('.header__status').toggleClass("header__status--active");
        });
      })(jQuery);
    }
  }]);
  return Accordion;
}();
var _default = Accordion;
exports.default = _default;

},{}],2:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var DatePicker = /*#__PURE__*/function () {
  function DatePicker() {
    _classCallCheck(this, DatePicker);
    this.init();
  }
  _createClass(DatePicker, [{
    key: "init",
    value: function init() {
      (function ($) {
        var $document = $(document),
          $body = $('body'),
          $datePickerScrollable = $('.js-date-picker-scrollable');
        $datePickerScrollable.on({
          'mouseenter': function mouseenter() {
            // save scroll position
            //var scrollPosition = $document.scrollTop();

            // add hack class to prevent workspace scroll when scroll outside
            $body.addClass('noscroll');

            // restore scroll position
            //element.scrollTop(scrollPosition);
          },

          'mouseleave': function mouseleave() {
            // save scroll position
            //var scrollPosition = element.scrollTop();

            // remove hack class to allow scroll
            $body.removeClass('noscroll');

            // restore scroll position
            //$document.scrollTop(scrollPosition);
          }
        });
      })(jQuery);
    }
  }]);
  return DatePicker;
}();
var _default = DatePicker;
exports.default = _default;

},{}],3:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var Social = /*#__PURE__*/function () {
  function Social() {
    _classCallCheck(this, Social);
    this.init();
  }
  _createClass(Social, [{
    key: "init",
    value: function init() {
      (function ($) {
        var $social = $('.js-social');
        var $footerInner = $('.js-footer-inner');
        var $body = $('body');
        moveSocial();
        function moveSocial() {
          if ($(window).width() <= 1366 && $footerInner.length) {
            if ($body.hasClass('is-mobile')) {
              $social.prependTo($footerInner);
            }
          }
        }
        $(window).on('resize orientationchange', function (event) {
          moveSocial();
        });
      })(jQuery);
    }
  }]);
  return Social;
}();
var _default = Social;
exports.default = _default;

},{}],4:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var Ajax //extend this class for each ajax call needed
= /*#__PURE__*/function () {
  function Ajax(props)
  //need to pass data for action, and anyextra data
  {
    _classCallCheck(this, Ajax);
    if (!props.action) return;
    // this.data = {
    //     action: this.props.action
    // }
    this.data = props;
    this.data.security = ajax_object.ajax_nonce;
    this.loading = false;
    this.ajax();
  }
  _createClass(Ajax, [{
    key: "preAjax",
    value: function preAjax() {} //overwrite
  }, {
    key: "ajax",
    value: function ajax() {
      var _this = this;
      if (this.loading) return;
      this.loading = true;
      this.preAjax();
      jQuery.ajax({
        type: "post",
        dataType: "json",
        url: ajax_object.ajax_url,
        data: this.data,
        success: function success(msg) {
          _this.successAction(msg);
        }
      });
    }
  }, {
    key: "successAction",
    value: function successAction(msg) {} //overwrite
  }]);
  return Ajax;
}();
var InsectAjax = /*#__PURE__*/function (_Ajax) {
  _inherits(InsectAjax, _Ajax);
  var _super = _createSuper(InsectAjax);
  function InsectAjax(props) {
    _classCallCheck(this, InsectAjax);
    return _super.call(this, props);
  }
  _createClass(InsectAjax, [{
    key: "preAjax",
    value: function preAjax() {
      this.articleWrap = document.querySelector('.homebkg .articles');
      this.spinner = document.querySelector('.hlk-spinner');
      this.articleWrap.innerHTML = '';
      this.spinner.classList.toggle('show');
    }
  }, {
    key: "successAction",
    value: function successAction(msg) {
      this.loading = false;
      this.spinner.classList.toggle('show');
      if (!msg.success) {
        jQuery('.current-bug-info').hide();
        return;
      }
      var html = msg.data;
      this.articleWrap.innerHTML = html;
    }
  }]);
  return InsectAjax;
}(Ajax);
var _default = InsectAjax;
exports.default = _default;

},{}],5:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var FilterAlert = /*#__PURE__*/function () {
  function FilterAlert() {
    _classCallCheck(this, FilterAlert);
    this.init();
  }
  _createClass(FilterAlert, [{
    key: "init",
    value: function init() {
      (function ($) {
        var $filterAlert = $('.js-filter-alert');
        var $filterAlertForm = $filterAlert.find('.js-filter-form');
        var $filterAlertToggle = $filterAlert.find('.js-toggle');
        var $filterAlertContent = $filterAlert.find('.js-content');
        var $filterAlertList = $('.js-filter-alert-list');
        var $filterAlertListContainerDesktop = $('.js-filter-alert-list-container-desktop');
        var $navigationSearch = $('.js-search');
        var $panelTitle = $filterAlert.find('.js-panel-title');
        var $filterInsect = $filterAlert.find('.js-filter-insect');
        var $filterState = $filterAlert.find('.js-filter-state');
        var $filterMonth = $filterAlert.find('.js-filter-month');
        var $filterYear = $filterAlert.find('.js-filter-year');
        var $filtersAll = $filterInsect.add($filterState).add($filterMonth).add($filterYear);
        var statusDataAll = [];
        var statusDataInsect = [];
        var statusDataState = [];
        var statusDataMonth = [];
        var statusDataYear = [];
        var filtersStatus = function openEachFilterAccordionIfAnyInputIsChecked() {
          $filtersAll.find('input[type=checkbox]:checked').each(function () {
            if ($(this).length) {
              $(this).closest('.accordion__content').css({
                'display': 'block'
              }).prev().addClass('header--active').find('header__status').addClass('header__status--active');
            }
          });
        };
        filtersStatus();
        var statesCapitalize = function capitalizeEachWordOfStates() {
          // On load open accordion - Test
          // $filterState.css({'overflow' : 'hidden', 'display' : 'block'}).prev().addClass('header--active').find('.header__status').addClass('header__status--active');

          $.each($('.js-filter-state label.container, .js-filter-alert-list .list__item--state'), function (index) {
            var stateTextCurrent = $(this).text().toLowerCase();
            stateTextCurrent = stateTextCurrent.toLowerCase().split(' ').map(function (stateText) {
              return stateText.charAt(0).toUpperCase() + stateText.substring(1);
            }).join(' ');
            $(this).contents().first()[0].textContent = stateTextCurrent;
          });
        };
        statesCapitalize();
        $filterAlertToggle.on("click", function (event) {
          $filterAlertContent.toggleClass('content--visible');
        });
        function uncheckFilterSelectOption(filterName, selectedItem) {
          filterName.find('input[type=checkbox]').each(function (index) {
            if (selectedItem.attr('data-name') == $(this).val()) {
              $(this).removeAttr('checked');
              selectedItem.remove();
            }
          });
          $filterAlertForm.submit();
        }
        $filterAlertList.on('click', '.list__item', function (event) {
          var $selectedItem = $(this);

          //Insect
          if ($selectedItem.hasClass('list__item--insect')) {
            uncheckFilterSelectOption($filterInsect, $selectedItem);
          }

          //State
          if ($selectedItem.hasClass('list__item--state')) {
            uncheckFilterSelectOption($filterState, $selectedItem);
          }

          //Month
          if ($selectedItem.hasClass('list__item--month')) {
            uncheckFilterSelectOption($filterMonth, $selectedItem);
          }

          //Year
          if ($selectedItem.hasClass('list__item--year')) {
            uncheckFilterSelectOption($filterYear, $selectedItem);
          }
        });

        //Insect
        $filterInsect.on('change', 'input[type=checkbox]', function (event) {
          var $selectedItem = $(this);
          if ($selectedItem.is(':checked')) {
            statusDataInsect.push($selectedItem.val());
            $filterAlertList.append('<li class="list__item list__item--insect" data-name="' + $selectedItem.val() + '">' + $selectedItem.parent().text() + '</li>');
          } else {
            statusDataInsect.pop($selectedItem.val());
            $filterAlertList.find('[data-name="' + $selectedItem.val() + '"]').remove();
          }
          $filterAlertForm.submit();

          // if(($.inArray($selectedItem.val(), statusDataInsect)) == -1){
          //     console.log('In array');
          //     $filterAlertList.find('[data-name="' + $selectedItem.val() + '"]').remove();
          // }else{
          //     console.log('Outside array');
          //     $filterAlertList.append('<li class="list__item list__item--insect" data-name="' + $selectedItem.val() + '">' + $selectedItem.parent().text() + '</li>');
          // }
        });

        //State
        $filterState.on('change', 'input[type=checkbox]', function (event) {
          var $selectedItem = $(this);
          if ($selectedItem.is(':checked')) {
            statusDataState.push($selectedItem.val());
            $filterAlertList.append('<li class="list__item list__item--state list__item--capitalize" data-name="' + $selectedItem.val() + '">' + $selectedItem.parent().text() + '</li>');
          } else {
            statusDataState.pop($selectedItem.val());
            $filterAlertList.find('[data-name="' + $selectedItem.val() + '"]').remove();
          }
          $filterAlertForm.submit();
        });

        //Month
        $filterMonth.on('change', 'input[type=checkbox]', function (event) {
          var $selectedItem = $(this);
          if ($selectedItem.is(':checked')) {
            statusDataMonth.push($selectedItem.val());
            $filterAlertList.append('<li class="list__item list__item--month" data-name="' + $selectedItem.val() + '">' + $selectedItem.parent().text() + '</li>');
          } else {
            statusDataMonth.pop($selectedItem.val());
            $filterAlertList.find('[data-name="' + $selectedItem.val() + '"]').remove();
          }
          $filterAlertForm.submit();
        });

        //Year
        $filterYear.on('change', 'input[type=checkbox]', function (event) {
          var $selectedItem = $(this);
          if ($selectedItem.is(':checked')) {
            statusDataYear.push($selectedItem.val());
            $filterAlertList.append('<li class="list__item list__item--year" data-name="' + $selectedItem.val() + '">' + $selectedItem.parent().text() + '</li>');
          } else {
            statusDataYear.pop($selectedItem.val());
            $filterAlertList.find('[data-name="' + $selectedItem.val() + '"]').remove();
          }
          $filterAlertForm.submit();
        });
        moveFilterAlertList();
        function moveFilterAlertList() {
          if ($(window).width() >= 980) {
            $filterAlertListContainerDesktop.append($filterAlertList);
            $panelTitle.text('Filters:');
          }
        }
        $(window).on('resize orientationchange', function (event) {
          moveFilterAlertList();
        });
      })(jQuery);
    }
  }]);
  return FilterAlert;
}();
var _default = FilterAlert;
exports.default = _default;

},{}],6:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var Pagination = /*#__PURE__*/function () {
  function Pagination() {
    _classCallCheck(this, Pagination);
    this.init();
  }
  _createClass(Pagination, [{
    key: "init",
    value: function init() {
      (function ($) {
        var $paginationList = $('.js-pagination').find('ul.page-numbers').addClass('pagination-list');
        $paginationList.find('li').addClass('pagination-list__item').children().addClass('pagination-list__subitem');
        $paginationList.find('.prev').addClass('pagination-list__subitem--prev').parent().addClass('pagination-list__item--prev');
        $paginationList.find('.next').addClass('pagination-list__subitem--next').parent().addClass('pagination-list__item--next');
        $paginationList.find('.dots').addClass('pagination-list__subitem--dots').parent().addClass('pagination-list__item--dots');
        $paginationList.find('a').addClass('pagination-list__subitem--link');
        $paginationList.find('.current').parent().addClass('pagination-list__item--current');
        $paginationList.each(function (index) {
          $(this).find('.pagination-list__item--dots, .pagination-list__item--next').prev().addClass('pagination-list__item--last');
          $(this).find('.pagination-list__item:last-of-type').not('.pagination-list__item--next').addClass('pagination-list__item--last');
        });
        var $paginationFirstItem = $paginationList.find('.pagination-list__item:first');
        if ($paginationFirstItem.length) {
          if ($paginationFirstItem.hasClass('pagination-list__item--prev')) {
            var $paginationItemToUpdate = $paginationFirstItem.next().children();
            if ($paginationItemToUpdate.text() == '1') {
              var paginationStringNew = '?paged=1';
              if ($paginationItemToUpdate.attr('href') == '') {
                $paginationItemToUpdate.attr('href', paginationStringNew);
              } else {
                var urlOld = $paginationItemToUpdate.attr('href');
                var urlNew = urlOld.replace('?', paginationStringNew + '&');
                $paginationItemToUpdate.attr('href', urlNew);
              }
            }
          }
        }
      })(jQuery);
    }
  }]);
  return Pagination;
}();
var _default = Pagination;
exports.default = _default;

},{}],7:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var PestSubnav = /*#__PURE__*/function () {
  function PestSubnav() {
    _classCallCheck(this, PestSubnav);
    this.init();
  }
  _createClass(PestSubnav, [{
    key: "init",
    value: function init() {
      (function ($) {
        var $pestInfoSubnavTarget = $('.js-pest-info-subnav-target');
        var $pestName = $pestInfoSubnavTarget.attr('data-pest-name');
        var pestInfoSubnav = "\n                <div class=\"pest-info\">\n                    <p class=\"pest-info__title\">Learn about the following with ".concat($pestName, ":</p>\n\n                    <ul class=\"js-smooth-scroll pest-info__list list-page-subnav\">\n                        <li class=\"list-page-subnav__item\"><a class=\"js-scroll-trigger list-page-subnav__link\" href=\"#identification\">Identification</a></li>\n                        <li class=\"list-page-subnav__item\"><a class=\"js-scroll-trigger list-page-subnav__link\" href=\"#lifecycle\">Lifecycle</a></li>\n                        <li class=\"list-page-subnav__item\"><a class=\"js-scroll-trigger list-page-subnav__link\" href=\"#tracking\">Tracking</a></li>\n                        <li class=\"list-page-subnav__item\"><a class=\"js-scroll-trigger list-page-subnav__link\" href=\"#management\">Management</a></li></a>\n                    </ul>\n                </div>");
        $pestInfoSubnavTarget.html(pestInfoSubnav);
      })(jQuery);
    }
  }]);
  return PestSubnav;
}();
var _default = PestSubnav;
exports.default = _default;

},{}],8:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var SearchAndNavigation = /*#__PURE__*/function () {
  function SearchAndNavigation() {
    _classCallCheck(this, SearchAndNavigation);
    this.init();
  }
  _createClass(SearchAndNavigation, [{
    key: "init",
    value: function init() {
      (function ($) {
        var $body = $('body');
        var $primaryNavigation = $('.js-primary-navigation');
        var $menuToggle = $primaryNavigation.find('.js-menu-toggle');
        var $search = $primaryNavigation.find('.js-search');
        $menuToggle.on('click', function (event) {
          if ($primaryNavigation.hasClass('toggled-on')) {
            $search.toggleClass('search-primary--visible');
          } else {
            $search.toggleClass('search-primary--visible');
          }
        });
        isMobile();
        searchDesktop();
        function isMobile() {
          if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
            $body.addClass('is-mobile');
          } else {
            $body.removeClass('is-mobile');
          }
        }
        function searchDesktop() {
          if ($(window).width() >= 1025) {
            $search.insertAfter($primaryNavigation);
          }
        }
        var subavigationMobile = function enablePrimarySubavigationMobile() {
          if ($body.hasClass('is-mobile')) {
            $primaryNavigation.find('.nav-menu > .menu-item-has-children').each(function () {
              $(this).find('> :first-child').addClass('menu-item-has-children__link').wrap('<div class="menu-item-has-children__group"></div>').after('<span class="js-toggle menu-item-has-children__sub-menu-toggle"></span>');
            });
          }
        };
        subavigationMobile();
        $primaryNavigation.find('.nav-menu > .menu-item-has-children').on("click", ".js-toggle", function () {
          $(this).toggleClass('menu-item-has-children__sub-menu-toggle--active').parent().toggleClass('menu-item-has-children__group--active').next().toggleClass("sub-menu--active").slideToggle();
        });
        $(window).on('resize orientationchange', function (event) {
          isMobile();
          searchDesktop();
          subavigationMobile();
        });
      })(jQuery);
    }
  }]);
  return SearchAndNavigation;
}();
var _default = SearchAndNavigation;
exports.default = _default;

},{}],9:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var SmoothScroll = /*#__PURE__*/function () {
  function SmoothScroll() {
    _classCallCheck(this, SmoothScroll);
    this.init();
  }
  _createClass(SmoothScroll, [{
    key: "init",
    value: function init() {
      (function ($) {
        var $smoothScroll = $('.js-smooth-scroll');
        var $masthead = $('#masthead');
        var $mastheadHeight = 0;
        if ($masthead.css('position') == 'fixed') {
          $mastheadHeight = $masthead.outerHeight();
        }
        $smoothScroll.on('click', '.js-scroll-trigger', function (e) {
          if (this.hash !== '' && $(this.hash).length) {
            e.preventDefault();
            var hash = this.hash;
            $('html, body').animate({
              scrollTop: $(hash).offset().top - $mastheadHeight
            }, 800);
          }
        });
      })(jQuery);
    }
  }]);
  return SmoothScroll;
}();
var _default = SmoothScroll;
exports.default = _default;

},{}],10:[function(require,module,exports){
"use strict";

var _pagination = _interopRequireDefault(require("./component/utilities/pagination.js"));
var _searchAndNavigation = _interopRequireDefault(require("./component/utilities/search-and-navigation.js"));
var _ajax = _interopRequireDefault(require("./component/utilities/ajax.js"));
var _accordion = _interopRequireDefault(require("./component/accordion/accordion.js"));
var _filterAlert = _interopRequireDefault(require("./component/utilities/filter-alert.js"));
var _pestSubnav = _interopRequireDefault(require("./component/utilities/pest-subnav.js"));
var _smoothScroll = _interopRequireDefault(require("./component/utilities/smooth-scroll.js"));
var _datePicker = _interopRequireDefault(require("./component/date-picker/date-picker"));
var _social = _interopRequireDefault(require("./component/social/social"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var searchAndNavigation = new _searchAndNavigation.default();
var pagination = new _pagination.default();
var accordion = new _accordion.default();
var filterAlert = new _filterAlert.default();
window.InsectAjax = _ajax.default;
var pestSubnav = new _pestSubnav.default();
var smoothScroll = new _smoothScroll.default();
var datePicker = new _datePicker.default();
var social = new _social.default();
// const search = new Search();

jQuery(window).scroll(function () {
  sessionStorage.scrollTop = jQuery(this).scrollTop();
});
(function ($) {
  if (sessionStorage.scrollTop != "undefined") {
    $(window).scrollTop(sessionStorage.scrollTop);
  }
})(jQuery);

},{"./component/accordion/accordion.js":1,"./component/date-picker/date-picker":2,"./component/social/social":3,"./component/utilities/ajax.js":4,"./component/utilities/filter-alert.js":5,"./component/utilities/pagination.js":6,"./component/utilities/pest-subnav.js":7,"./component/utilities/search-and-navigation.js":8,"./component/utilities/smooth-scroll.js":9}]},{},[10]);
